import React from "react";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";
import { LookupManager } from "./lookup-manager";
import AdminPortalAppService from "../../../application/platform/admin-portal/admin-portal-app-service";

const OrgaosFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Órgãos"}>
            <LookupManager
                title="Órgãos"
                fields={[{ key: "nomOrgao", label: "Nome do Órgão", required: true, readKey: "name", maxLength: 100 }]}
                listFn={AdminPortalAppService.listOrgaos}
                addUpdateFn={AdminPortalAppService.addUpdateOrgao}
                variant="standalone"
            />
        </BaseInternalFormFactory>
    );
};

export default OrgaosFactory;
